export default [
  {
    path: '/halaman',
    name: 'halaman',
    component: () => import('@/views/halaman/Halaman.vue'),
    meta: {
      pageTitle: 'Halaman',
      breadcrumb: [
        {
          text: 'Halaman',
          active: true,
        },
      ],
      middleware: 'Auth',
    },
  }
]
